import type { TFunction } from 'i18next'
import { PRODUCT_TYPES } from 'services/ProductTypeState'

export function getRemoveItemConfirmationMessage(
  productType: PRODUCT_TYPES,
  t: TFunction
): string {
  switch (productType) {
    case PRODUCT_TYPES.CLASSIC:
      return t('order.remove_item_popup.tiles')
    case PRODUCT_TYPES.PHOTO_BOOK:
      return t('order.remove_item_popup.photo_book')
    default:
      return t('order.remove_item_popup.title')
  }
}
